import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ChangePasswordComponent } from '../../modal/change-password/change-password.component';
import { AmToasterService } from '@angularminds/am-toaster';

@Component({
  selector: 'am-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
  bsModalRef: BsModalRef;
  user: any = {};

  constructor(
    private bsModalService: BsModalService,
    private router: Router,
    private amToasterService: AmToasterService,
    private authService: AuthService,
    private restService: RestService,
  ) {}

  ngOnInit() {
    this.getUserProfile();
  }

  getUserProfile() {
    this.authService.currentUser.subscribe(user => {
      this.user = user;
    });
  }

  getInitials(str) {
    return str ? str.charAt(0) : '';
  }

  showChangePasswordModal() {
    this.bsModalRef = this.bsModalService.show(ChangePasswordComponent, {
      ignoreBackdropClick: true,
      class: 'modal-md',
    });
  }

  goPlaces(url) {
    this.router.navigate(['/', url]);
  }

  logout() {
    this.authService.logout().subscribe(
      response => {
        window.location.href = this.authService.getRequestUrl('/auth/login');
      },
      error => {
        this.amToasterService.show('error', error, 'Error!');
      },
    );
  }
}
